import { formatNumber, formatDecimalPlus } from 'Util';

const Consensus = ({ data, siseInfo }) => {

  const pList = [];
  if (siseInfo && siseInfo.trdPrc) {
    pList.push(siseInfo.trdPrc ? siseInfo.trdPrc : 0);
  } else {
    pList.push(data.CLOSE ? data.CLOSE : 0);
  }

  if (data.MIN_FINLIT_TARGET) {
    pList.push(data.MIN_FINLIT_TARGET);
  }
  if (data.MAX_FINLIT_TARGET) {
    pList.push(data.MAX_FINLIT_TARGET);
  }
  if (data.MIN_CON_TARGET) {
    pList.push(data.MIN_CON_TARGET);
  }
  if (data.MAX_CON_TARGET) {
    pList.push(data.MAX_CON_TARGET);
  }
  if (data.MIN_52W_PRC) {
    pList.push(data.MIN_52W_PRC);
  }
  if (data.MAX_52W_PRC) {
    pList.push(data.MAX_52W_PRC);
  }

  const min = Math.min(...pList);
  const max = Math.max(...pList);
  const gap = max - min; //80%

  for (let i = 0; i < pList.length; i++) {
    pList[i] -= min;
    pList[i] = pList[i]/gap*80;
  }

  function renderingSise() {
    if (siseInfo && siseInfo.trdPrc) {
      return (
        <>
          <span>현재가</span>
          <strong>{formatNumber(siseInfo.trdPrc)}원</strong>
        </>
      )
    } else {
      return (
        <>
          <span>전일종가</span>
          <strong>{formatNumber(data.CLOSE)}원</strong>
        </>
      )
    }
  }

  function renderingConsensusRate(val) {
    let rateClassName = "";
    if (val > 0) {
      rateClassName = "txt_red";
    } else if (val < 0) {
      rateClassName = "txt_blue";
    }

    return (
      <span className={rateClassName}>{formatDecimalPlus(val, 1)}%</span>
    )
  }

  function renderingConsensusComment(val1, val2) {
    if ((val1 > 0) && (val2 > 0)) {
      return (
        <span className="txt_red"> 상승 여력</span>
      );
    } else if ((val1 < 0) && (val2 < 0)) {
      return (
        <span className="txt_blue"> 하락 위험</span>
      );
    } else {
      return (
        <span className="txt_basic"> 적정 수준</span>
      );
    }
  }

  let index = 0;

	return (
    <div className="chart">
      <div className="card type2">
        <div className="chart_contnts">
          <div className="result_area">
            <div className="closing_price" style={{left: (pList[index] > 75 ? 75 : pList[index]) + "%"}}>
              {renderingSise()}
            </div>
            { data.MIN_FINLIT_TARGET && data.MAX_FINLIT_TARGET &&
              <div className="result todbot" style={{left: (pList[++index] > 59 ? 59 : pList[index]) + "%"}}>
                <strong>토브스탁</strong>
                <div className="bar_graph_item" style={{width: (pList[++index]-pList[index-1])+"%"}}>
                  <div className="min_max">
                    <span className="min">{formatNumber(data.MIN_FINLIT_TARGET)}원</span>
                    <span className="max">{formatNumber(data.MAX_FINLIT_TARGET)}원</span>
                  </div>
                  <div className="bar"></div>
                </div>
              </div>
            }
            { data.MIN_CON_TARGET && data.MAX_CON_TARGET &&
              <div className="result consensus" style={{left: (pList[++index] > 59 ? 59 : pList[index]) + "%"}}>
                <strong>컨센서스</strong>
                <div className="bar_graph_item" style={{width: (pList[++index]-pList[index-1])+"%"}}>
                  <div className="min_max">
                    <span className="min">{formatNumber(data.MIN_CON_TARGET)}원</span>
                    <span className="max">{formatNumber(data.MAX_CON_TARGET)}원</span>
                  </div>
                  <div className="bar"></div>
                </div>
              </div>
            }
            { data.MIN_52W_PRC && data.MAX_52W_PRC &&
              <div className="result week" style={{left: (pList[++index] > 59 ? 59 : pList[index]) + "%"}}>
                <strong>최소/최대<span>52주</span></strong>
                <div className="bar_graph_item" style={{width: (pList[++index]-pList[index-1])+"%"}}>
                  <div className="min_max">
                    <span className="min">{formatNumber(data.MIN_52W_PRC)}원</span>
                    <span className="max">{formatNumber(data.MAX_52W_PRC)}원</span>
                  </div>
                  <div className="bar"></div>
                </div>
              </div>
            }
          </div>
          <div className="predict_box">
            { data.UPSIDE 
              ?
              <p>
                
                공정가치, {siseInfo && siseInfo.trdPrc > 0 ? '현재가' : '전일종가'}보다
                <strong>
                  {renderingConsensusRate(data.MIN_FINLIT_UPSIDE)}
                  <i> ~ </i>
                  {renderingConsensusRate(data.MAX_FINLIT_UPSIDE)}
                  {renderingConsensusComment(data.MIN_FINLIT_UPSIDE, data.MAX_FINLIT_UPSIDE)}
                </strong>
              </p>
              :
              <div className="text">
                <span>공정가치</span>
                <strong className="txt_gray">AI 데이터 학습 중입니다.</strong>
              </div>
            }
          </div>
          {/* 설명: predict_box 바로 아래 같은 카드 내부에 연한 구분선과 설명 텍스트 추가 */}
          <div style={{marginTop:14}}>
            <div style={{marginTop:12, color:'#333', lineHeight:1.8}}>
              <strong style={{fontWeight:700, fontSize:16, display:'block', marginBottom:0}}>공정 가치</strong>
              <div style={{fontWeight:600, fontSize:14, color:'#666'}}>※ 토브스탁 AI 알고리즘이 절대수익모델(RIM) 및 상대평가 모델을 통해 산정한 기업의 적정가치입니다.</div>
              <strong style={{fontWeight:700, fontSize:16, display:'block', marginTop:6, marginBottom:0}}>컨센서스</strong>
              <div style={{fontWeight:600, fontSize:14, color:'#666'}}>※ 주요 증권사 3곳 이상의 애널리스트가 분석한 기업의 평균 목표주가 수준을 의미합니다.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Consensus;
